import { render, staticRenderFns } from "./template-preview.vue?vue&type=template&id=c4bed542&scoped=true&"
import script from "./template-preview.ts?vue&type=script&lang=ts&"
export * from "./template-preview.ts?vue&type=script&lang=ts&"
import style0 from "./template-preview.scss?vue&type=style&index=0&id=c4bed542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bed542",
  null
  
)

export default component.exports